import { LockClosedIcon } from '@heroicons/react/24/solid';
import type { Solicitacao } from '../../../models';
import { calcularAlertaMovimentacao, CLASSE_COR_POR_NIVEL_ALERTA, CLASSE_BORDA_POR_NIVEL_ALERTA } from '../../../models';
import { TIPO_SOLICITACAO_LABELS } from '../../NovaSolicitacaoPage/novaSolicitacaoPage.definitions';
import type { Pendencia } from '../../SolicitacaoDetailsPage/pendenciaMovimentacao';

interface SolicitacoesKanbanCardProps {
  solicitacao: Solicitacao;
  alerta: ReturnType<typeof calcularAlertaMovimentacao> | null;
  pendencia: Pendencia | null;
  dataFormatada: string | null;
  clienteNome: string | null;
  arrastavel: boolean;
  onSelect: (id: string) => void;
}

export default function SolicitacoesKanbanCard({
  solicitacao,
  alerta,
  pendencia,
  dataFormatada,
  clienteNome,
  arrastavel,
  onSelect,
}: SolicitacoesKanbanCardProps) {
  const corBorda = CLASSE_BORDA_POR_NIVEL_ALERTA[alerta?.nivel ?? 'neutro'];

  return (
    <button
      type="button"
      draggable={arrastavel}
      onDragStart={(event) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('text/plain', solicitacao.id);
      }}
      onClick={() => onSelect(solicitacao.id)}
      className={`relative rounded-md border border-l-4 border-gray-200 bg-white p-2 text-left text-sm shadow-sm hover:border-blue-300 hover:shadow ${corBorda} ${
        arrastavel ? 'cursor-grab active:cursor-grabbing' : ''
      }`}
    >
      {/* Sinaliza de cara — sem precisar tentar arrastar pra "Concluída" pra descobrir —
          que essa Solicitação tem algo pendente bloqueando a conclusão. */}
      {pendencia && (
        <LockClosedIcon
          className="absolute right-1.5 top-1.5 h-3.5 w-3.5 text-amber-500"
          title={`Bloqueia conclusão: ${pendencia.label}`}
        />
      )}
      <p className="pr-4 font-montserrat font-medium text-gray-900">{solicitacao.colaboradorNome}</p>
      <p className="text-xs text-gray-500">
        {TIPO_SOLICITACAO_LABELS[solicitacao.tipoSolicitacao]}
        {clienteNome && ` · ${clienteNome}`}
      </p>
      {dataFormatada && <p className="mt-0.5 text-xs text-gray-400">Previsto: {dataFormatada}</p>}
      {(alerta || pendencia) && (
        <div className="mt-1.5 flex flex-wrap gap-1">
          {alerta && (
            <span className={`rounded-full px-1.5 py-0.5 text-xs font-semibold ${CLASSE_COR_POR_NIVEL_ALERTA[alerta.nivel]}`}>
              {alerta.emoji} {alerta.texto}
            </span>
          )}
          {pendencia && (
            <span className="rounded-full bg-amber-100 px-1.5 py-0.5 text-xs font-semibold text-amber-800">
              {pendencia.emoji} {pendencia.label}
            </span>
          )}
        </div>
      )}
    </button>
  );
}
